import { FC, useState } from 'react';
// Models
import IAnswer from 'models/Answer';
// Component
import { Button } from 'components/Buttons';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuestionAnswerPicked, selectIsAnyAnswerCorrect } from 'store/player/playerSelectors';
import { setQuestionAnswerPicked, setQuestionStart } from 'store/player/playerSlice';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
import QuizTypes from 'types/QuizTypes';

type Props = {
  answer: IAnswer;
  onClick: (answer:{ ref:string, title:string, correct:boolean }) => void;
  disabled?: boolean;
};

const AnswerButton:FC<Props> = ({
  // Props
  answer, onClick, disabled = false,
}) => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const questionAnswerPicked:boolean = useAppSelector(selectQuestionAnswerPicked);
  const isAnyAnswerCorrect:boolean = useAppSelector(selectIsAnyAnswerCorrect);
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const { highlightCorrectAnswer } = quiz.questionsSettings;

  const [ clicked, setClicked ] = useState(false);

  const handleClick = () => {
    if(clicked) return;
    const { ref, title, correct } = answer;

    dispatch(setQuestionStart(false));

    onClick({ ref, title, correct });
    dispatch(setQuestionAnswerPicked(true));

    setClicked(true);
  }

  const isScoringQuiz = quiz.type === QuizTypes.Scoring;
  const isPredictionQuiz = quiz.type === QuizTypes.Prediction;

  const correctColor = quiz.questionsSettings.correctAnswerColor;
  const incorrectColor = quiz.questionsSettings.incorrectAnswerColor;

  const backgroundColor = questionAnswerPicked && clicked && isScoringQuiz
    ? isAnyAnswerCorrect || answer.correct
      ? correctColor
      : incorrectColor
    : highlightCorrectAnswer && !clicked && questionAnswerPicked && answer.correct && isScoringQuiz
      ? correctColor
      : '';
  const textColor = backgroundColor ? 'white' : '';

  return (
    <Button
      className={`
        ${questionAnswerPicked ? 'pointer-events-none' : ''}
        ${isPredictionQuiz ? clicked ? 'selected-answer-button' : 'bg-linear' : ''}
        normal-case font-bold
      `}
      style={{
        backgroundColor: backgroundColor ? backgroundColor : undefined,
        color: textColor ? textColor : undefined,
      }}
      onClick={handleClick}
      disabled={disabled || clicked}
    >
      <span className={disabled ? 'blur-sm  select-none' : ''}>{answer.title}</span>
    </Button>
  )
}

export default AnswerButton;
